import getApiConfig from '../config/apiConfig';

const handleResponse = async (response) => {
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
  }
  return response.json();
};

const adminService = {
  // Get all admin users
  async getAdminUsers() {
    try {
      const { apiBaseUrl } = getApiConfig();
      const response = await fetch(`${apiBaseUrl}/admin/users`);
      return handleResponse(response);
    } catch (error) {
      console.error('Error getting admin users:', error);
      throw error;
    }
  },

  // Check if current user is admin
  async isCurrentUserAdmin(userEmail) {
    try {
      const adminUsers = await this.getAdminUsers();
      
      if (!userEmail) {
        return false;
      }
      
      return adminUsers.some(admin => admin.UserId === userEmail);
    } catch (error) {
      console.error('Error checking admin status:', error);
      return false;
    }
  }
};

export default adminService; 